/**
 * SyncTrack same-app connector Connect flow.
 *
 * SyncTrack APIs (e.g. Benchmark) already accept the logged-in Chat/UI JWT.
 * Connect stores that session access token on the connector instance so MCP
 * can call /synctrack/api/... with the same auth the UI uses — no separate
 * third-party OAuth redirect.
 *
 * After the first Connect, login/app bootstrap rebinds the JWT via
 * POST /synctrack/synctrack-connector/sync-session (clients need no Connector menu).
 */
export const getSyncTrackCredentialsAndCreateToken = async (connectorId, mcId, masterConnectors) => {
  const syncTrackMaster = masterConnectors.find(
    (mc) =>
      (mc.mcRecId?.toString() === mcId?.toString() || mc.mcId?.toString() === mcId?.toString()) &&
      (mc.mcConnectorType === 'SYNCTRACK' ||
        (mc.mcName && mc.mcName.toLowerCase().replace(/\s+/g, '') === 'synctrack'))
  );

  if (!syncTrackMaster) {
    throw new Error('SyncTrack master connector not found');
  }

  const accessToken = localStorage.getItem('token');
  if (!accessToken || !String(accessToken).trim()) {
    throw new Error('No logged-in SyncTrack session token found. Sign in again, then Connect.');
  }

  // Prefer JWT exp when present; otherwise default to 1 hour.
  let expiresIn = 3600;
  try {
    const parts = String(accessToken).split('.');
    if (parts.length >= 2) {
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      if (payload?.exp) {
        const secondsLeft = Math.floor(payload.exp - Date.now() / 1000);
        if (secondsLeft > 60) {
          expiresIn = secondsLeft;
        }
      }
    }
  } catch {
    // keep default expiresIn
  }

  const refreshToken = localStorage.getItem('refreshToken') || localStorage.getItem('refresh_token') || null;

  return {
    access_token: accessToken.trim(),
    token_type: 'Bearer',
    expires_in: expiresIn,
    refresh_token: refreshToken,
  };
};
